
(function(){
"use strict";
var KEY="jimora_quote_v3";
var items=[];
var coverage={status:"loading",states:[],checkedAt:0,loaded:false,changed:false,pending:null};
var COVERAGE_MAX_AGE=60000;
function $(s,root){return(root||document).querySelector(s);}
function make(tag,text,cls){var e=document.createElement(tag);if(cls)e.className=cls;e.textContent=text||"";return e;}
function load(){try{var x=JSON.parse(localStorage.getItem(KEY)||"[]");return Array.isArray(x)?x.filter(function(i){return i&&i.handle&&i.variantId&&i.qty>0;}).slice(0,100):[];}catch(e){return [];}}
function store(){try{localStorage.setItem(KEY,JSON.stringify(items));}catch(e){}}
function handle(url){try{var p=new URL(url,location.origin).pathname.split("/"),i=p.indexOf("products");return i>=0?p[i+1]:null;}catch(e){return null;}}
function value(s){return $(s)?$(s).value.trim():"";}
function coverageText(key){return $("#jr-widget").getAttribute("data-jr-coverage-"+key)||"";}
function stateAllowed(){return coverage.states.some(function(state){return state.name===value("#jr-state");});}
function coverageFresh(){return coverage.status==="ready"&&Date.now()-coverage.checkedAt<COVERAGE_MAX_AGE;}
function updateSubmit(){
var button=$("#jr-submit");
if(button)button.disabled=!items.length||!coverageFresh()||!stateAllowed();
}
function updateCoverageStatus(){
var state=$("#jr-state"),message=$("#jr-coverage-message"),retry=$("#jr-coverage-retry");
var kind=coverage.status==="ready"?(coverage.states.length?(coverage.changed?"changed":"available"):"none"):coverage.status;
var copy=coverageText(kind).replace("__STATES__",coverage.states.map(function(area){return area.name;}).join(", "));
if(message)message.textContent=copy;
if(retry){retry.hidden=coverage.status!=="error";retry.disabled=coverage.status==="loading";}
if(state){state.setAttribute("aria-busy",String(coverage.status==="loading"));state.setCustomValidity(coverage.status==="ready"?(stateAllowed()?"":coverage.states.length?coverageText(coverage.changed?"changed":"select"):copy):copy);}
$("#jr-coverage-status").classList.toggle("jr-coverage-error",coverage.status==="error"||kind==="none"||kind==="changed");
updateSubmit();
}
function updateCoverageAnnouncement(){
if(coverage.status!=="ready")return;
var names=coverage.states.map(function(state){return state.name;});
var copy=names.length&&names.length<=3?coverageText("announcement").replace("__STATES__",names.join(", ")):coverageText("summary");
document.querySelectorAll("[data-jr-coverage-announcement-text]").forEach(function(el){el.textContent=copy;});
}
function applyCoverage(data){
if(!data||data.schemaVersion!==1||!Array.isArray(data.states)||data.states.length>32)throw Error("Invalid coverage");
var codes=new Set(),names=new Set();
var states=data.states.map(function(state){
if(!state||typeof state.code!=="string"||!/^MX-[A-Z]{3}$/.test(state.code)||typeof state.name!=="string"||!state.name.trim()||state.name.length>100||codes.has(state.code)||names.has(state.name))throw Error("Invalid coverage state");
codes.add(state.code);names.add(state.name);return {code:state.code,name:state.name};
});
var select=$("#jr-state"),previous=select.value;
var next=names.has(previous)?previous:(!previous&&!coverage.loaded&&states.length===1?states[0].name:"");
coverage.changed=Boolean(previous&&!names.has(previous))||(!previous&&coverage.changed);
select.replaceChildren();
if(states.length!==1||!next){var placeholder=make("option",coverageText("select"));placeholder.value="";select.appendChild(placeholder);}
states.forEach(function(state){var option=make("option",state.name);option.value=state.name;option.dataset.stateCode=state.code;select.appendChild(option);});
select.value=next;
coverage.states=states;coverage.status="ready";coverage.checkedAt=Date.now();coverage.loaded=true;
updateCoverageStatus();updateCoverageAnnouncement();prepare();
}
function loadCoverage(force){
if(coverage.pending)return coverage.pending;
if(!force&&coverageFresh())return Promise.resolve(true);
coverage.status="loading";updateCoverageStatus();
coverage.pending=(async function(){
var controller=new AbortController(),timeout=setTimeout(function(){controller.abort();},6000);
try{
var response=await fetch($("#jr-widget").getAttribute("data-jr-coverage-url"),{credentials:"omit",cache:"no-store",signal:controller.signal});
if(!response.ok)throw Error("Coverage unavailable");
applyCoverage(await response.json());return true;
}catch(error){coverage.status="error";updateCoverageStatus();return false;}
finally{clearTimeout(timeout);coverage.pending=null;}
})();
return coverage.pending;
}
function prepare(){
var contactName=$("#jr-contact-name");
if(contactName)contactName.value=[value("#jr-first-name"),value("#jr-last-name")].filter(Boolean).join(" ");
var address=$("#jr-address");
if(address&&$("#jr-street"))address.value=[
[value("#jr-street"),value("#jr-exterior")].filter(Boolean).join(" "),
value("#jr-interior")?"Int. "+value("#jr-interior"):"",
value("#jr-neighborhood")?"Col. "+value("#jr-neighborhood"):"",
value("#jr-postal")?"C.P. "+value("#jr-postal"):"",
value("#jr-city"),value("#jr-state")].filter(Boolean).join(", ");
var lines=["SOLICITUD JIMORA - COTIZACION WEB","","PRODUCTOS"];
items.forEach(function(i,n){lines.push((n+1)+". "+i.title+(i.variant&&i.variant!=="Default Title"?" - "+i.variant:""));
lines.push("Cantidad: "+i.qty+" | SKU: "+(i.sku||"Sin SKU")+" | Shopify variante: "+i.variantId);
lines.push("Producto: "+location.origin+"/products/"+i.handle);});
lines.push("","DATOS DE CONTACTO","Nombre: "+value("#jr-contact-name"),
"Empresa: "+value("#jr-company"),"Correo: "+value("#jr-email"),"Telefono: "+value("#jr-phone"));
lines.push("","DATOS DEL EVENTO","Fecha: "+value("#jr-date"),"Invitados: "+value("#jr-guests"),
"Tipo: "+value("#jr-type"),"Direccion: "+value("#jr-address"),
"Entre que calles: "+value("#jr-cross-streets"),"Referencia exterior: "+value("#jr-address-reference"),
"Entrega: "+value("#jr-delivery"),"Recoleccion: "+value("#jr-pickup"),
"Notas: "+value("#jr-notes"),"","Estatus: Solicitud recibida; pendiente de confirmacion");
$("#jr-body").value=lines.join("\n");
}
function open(){
var menu=$("header-drawer details[open] > summary");if(menu)menu.click();
var search=$("details-modal details[open] .modal__close-button");if(search)search.click();
$("#jr-drawer").hidden=false;$("#jr-backdrop").hidden=false;document.body.classList.add("jr-open");
var launch=$("#jr-launch");if(launch)launch.setAttribute("aria-expanded","true");
$("#jr-close").focus();
loadCoverage();
}
function close(){
$("#jr-drawer").hidden=true;$("#jr-backdrop").hidden=true;document.body.classList.remove("jr-open");
var launch=$("#jr-launch");if(launch){launch.setAttribute("aria-expanded","false");launch.focus();}
}
function refresh(){
var area=$("#jr-items");if(!area)return;area.replaceChildren();
var sum=items.reduce(function(a,b){return a+b.qty;},0);
var count=$("#jr-count"),launch=$("#jr-launch");
if(count)count.textContent=sum>999?"999+":String(sum);
if(launch){launch.setAttribute("aria-label",launch.dataset.jrLabel+" ("+sum+")");launch.setAttribute("aria-expanded",String(!$("#jr-drawer").hidden));}
updateSubmit();
if(!items.length)area.appendChild(make("p","Agrega productos del catálogo para crear tu cotización.","jr-muted"));
items.forEach(function(item,i){
var row=make("div","","jr-item"),info=make("div",""),controls=make("div","","jr-controls");
info.appendChild(make("strong",item.title));
if(item.variant&&item.variant!=="Default Title")info.appendChild(make("span",item.variant,"jr-sub"));
function button(label,fn,css){var b=make("button",label,css);b.type="button";b.addEventListener("click",fn);return b;}
controls.appendChild(button("−",function(){if(items[i].qty===1)items.splice(i,1);else items[i].qty--;store();refresh();}));
controls.appendChild(make("span",String(item.qty)));
controls.appendChild(button("+",function(){items[i].qty=Math.min(9999,items[i].qty+1);store();refresh();}));
controls.appendChild(button("×",function(){items.splice(i,1);store();refresh();},"jr-remove"));
row.appendChild(info);row.appendChild(controls);area.appendChild(row);
});
prepare();
}
async function getProduct(h){var r=await fetch("/products/"+encodeURIComponent(h)+".js",{credentials:"same-origin"});
if(!r.ok)throw Error("No se pudo consultar el producto.");return await r.json();}
function add(p,v,qty,h){
if(!v)throw Error("Selecciona una variante antes de continuar.");
qty=Math.max(1,Math.min(9999,parseInt(qty,10)||1));
var id=String(v.id),existing=items.find(function(i){return i.handle===h&&i.variantId===id;});
if(existing)existing.qty=Math.min(9999,existing.qty+qty);
else items.push({title:p.title,variant:v.public_title||v.title||"",sku:v.sku||"",handle:h,variantId:id,qty:qty});
store();refresh();open();
}
function buttons(){
document.querySelectorAll(".card-wrapper").forEach(function(card){
if($(".jr-add",card))return;
var a=$('.card__heading a[href*="/products/"]',card),place=$(".card__information",card),h=a&&handle(a.href);
if(!place||!h)return;
var b=make("button","Agregar a cotización","jr-add");b.type="button";
b.addEventListener("click",async function(e){e.preventDefault();e.stopPropagation();b.disabled=true;b.textContent="Agregando...";
try{var p=await getProduct(h);if(p.variants.length>1){location.href="/products/"+h;return;}add(p,p.variants[0],1,h);}
catch(err){alert(err.message||"No fue posible agregar el producto.");}
finally{b.disabled=false;b.textContent="Agregar a cotización";}});
place.appendChild(b);
});
var h=handle(location.href),panel=$(".product__info-container");
if(!h||!panel||$(".jr-add",panel))return;
var b=make("button","Agregar a cotización","jr-add button");b.type="button";
b.addEventListener("click",async function(){
b.disabled=true;b.textContent="Agregando...";
try{var p=await getProduct(h);
var inp=$('.product__info-container form[action*="/cart/add"] input[name="id"]');
var chosen=inp&&inp.value||new URLSearchParams(location.search).get("variant");
var v=p.variants.find(function(x){return String(x.id)===String(chosen);});
if(!v&&p.variants.length===1)v=p.variants[0];
var q=$(".product__info-container input.quantity__input");
add(p,v,q&&q.value||1,h);
}catch(err){alert(err.message||"No fue posible agregar el producto.");}
finally{b.disabled=false;b.textContent="Agregar a cotización";}});
var form=$("product-form",panel);
if(form&&form.parentElement)form.parentElement.insertBefore(b,form.nextSibling);
else panel.appendChild(b);
}
function init(){
if(!$("#jr-widget"))return;
items=load();
$("#jr-close").addEventListener("click",close);
$("#jr-backdrop").addEventListener("click",close);
document.addEventListener("keydown",function(e){
var drawer=$("#jr-drawer");if(drawer.hidden)return;
if(e.key==="Escape"){e.preventDefault();close();return;}
if(e.key!=="Tab")return;
var focusable=Array.from(drawer.querySelectorAll('button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),a[href],[tabindex="0"]')).filter(function(el){return !el.hidden&&el.getClientRects().length;});
var first=focusable[0],last=focusable[focusable.length-1];
if(e.shiftKey&&(document.activeElement===first||!drawer.contains(document.activeElement))){e.preventDefault();if(last)last.focus();}
else if(!e.shiftKey&&(document.activeElement===last||!drawer.contains(document.activeElement))){e.preventDefault();if(first)first.focus();}
});
var d=$("#jr-date"),now=new Date();
d.min=now.getFullYear()+"-"+String(now.getMonth()+1).padStart(2,"0")+"-"+String(now.getDate()).padStart(2,"0");
var quoteForm=$("#JimoraCotizaForm");
quoteForm.addEventListener("input",prepare);
quoteForm.addEventListener("change",prepare);
$("#jr-state").addEventListener("change",function(){coverage.changed=false;updateCoverageStatus();prepare();});
$("#jr-coverage-retry").addEventListener("click",function(){loadCoverage(true);});
quoteForm.addEventListener("submit",function(e){
if(!items.length){e.preventDefault();open();return;}
if(!coverageFresh()||!stateAllowed()){
e.preventDefault();
if(!coverageFresh())loadCoverage(true);else updateCoverageStatus();
$("#jr-state").focus();return;
}
prepare();
});
if($("#jr-success")){items=[];store();open();}
document.addEventListener("click",function(e){if(e.target.closest("#jr-launch")){e.preventDefault();open();return;}var link=e.target.closest("a[href]");if(link&&new URL(link.href,location.origin).pathname==="/cart"){e.preventDefault();open();}});
document.addEventListener("shopify:section:load",function(){refresh();updateCoverageAnnouncement();});
if(location.pathname==="/cart")location.replace("/collections/all");
buttons();refresh();loadCoverage();
setInterval(function(){if(!$("#jr-drawer").hidden&&document.visibilityState!=="hidden")loadCoverage(true);},45000);
document.addEventListener("visibilitychange",function(){if(document.visibilityState==="visible"&&!$("#jr-drawer").hidden)loadCoverage();});
var main=$("#MainContent");
if(main)new MutationObserver(buttons).observe(main,{childList:true,subtree:true});
}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init);else init();
})();

